import { gql } from 'apollo-boost';

export default gql`
  mutation orderPartialRefund($input: OrderPartialRefundInput!) {
    orderPartialRefund(input: $input)
  }
`;
